var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ferrormessages",attrs:{"id":_vm.errorsContId,"role":"alert","aria-atomic":"true"}},_vm._l((_vm.errors),function(msg,idx){return _c('div',{key:`${_vm.errorsContId}_${idx}_err`,staticClass:"ferrormessages_message"},[_vm._v(" "+_vm._s(msg)+" ")])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }